import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, TextField, Button } from '@mui/material';
import FormErrors from '../../components/FormErrors';
import { requestLoginCode } from '../../lib/allauth';
import { Navigate } from 'react-router-dom';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseTextField from '../../components/BaseTextField';
import BaseFormContainer from '../../components/BaseFormContainer';


const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});

export default function RequestLoginCode() {
  const [email, setEmail] = useState('');
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    requestLoginCode(email)
      .then((content) => setResponse((r) => ({ ...r, content })))
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .finally(() => setResponse((r) => ({ ...r, fetching: false })));
  }

  if (response.content?.status === 401) {
    return <Navigate to='/account/login/code/confirm' />;
  }

  return (
    <BackgroundContainer>
      <BaseFormContainer>
        <BaseHeader sx={{ fontSize: '2rem' }}>Mail me a sign-in code</BaseHeader>
        <Subtitle sx={{
          marginBottom: '20px',
          fontSize: '1.2rem',
          '@media (max-width: 400px)': {
            fontSize: '1.1rem',
          },
          '@media (max-width: 360px)': {
            fontSize: '1rem',
          },
          '@media (max-width: 320px)': {
            fontSize: '0.95rem',
          },
        }} color="white" align="center" marginBottom={2}>
          You will receive an email containing a special code for a password-free sign-in.
        </Subtitle>
        <FormErrors errors={response.content?.errors} />
        <BaseTextField
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
        />
        <BaseButton disabled={response.fetching} onClick={submit}>
          Request Code
        </BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>
  );
}
